var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIArrowSmLeft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 16,
    viewBox: "0 0 8 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.35539 3L7.0625 3.70711L2.41605 8.35355L7.0625 13L6.35539 13.7071L1.00184 8.35355L6.35539 3Z",
    fill: "#82868C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIArrowSmLeft);
export default __webpack_public_path__ + "static/media/i_arrow_sm_left.bd30c32ff3e4618de75701d5248e5f0a.svg";
export { ForwardRef as ReactComponent };